<template>
  <Modal title="专属投保地址" width="600" v-model="visible" class="my-modal get-link-modal" :mask-closable="false" :footer-hide="true">
    <div class="right-box">
      <div class="title-box">
        <div class="text">您可复制赠险投保链接或下载二维码发送给客户</div>
      </div>
      <div class="link-box" v-show="mLink">
        <div class="row">
          <div class="label">投保链接</div>
          <a class="text" :href="mLink" target="_blank">{{mLink}}</a>
          <div class="btn" @click="$units.copyUrl(mLink,false,true)">复制链接</div>
        </div>
        <div class="row">
          <div class="label">投保二维码</div>
          <vueQr :text="mLink" v-if="mLink" :size="200" :margin="0" ref="vueQr" />
          <div class="btn" @click="downloadImg()">下载二维码</div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import vueQr from "vue-qr";
export default {
  props: [],
  components: {
    vueQr
  },
  data() {
    return {
      visible: false,
      loading: false,
      mLink: '',
      data:{}
    }
  },
  mounted() {},
  methods: {
    // 打开弹窗
    open(data) {
      if(data.salesStatus == 1){
        return  this.$notice.error("产品已停售，不能赠送了噢")
      }
      this.data = data;
      this.mLink = ''
      this.getStotLink();
    },
    getStotLink() {
      this.$notice.showLoading();
      this.$http({
        type: 'POST',
        url: '/buz/giveawayProduct/getInsureUrl',
        data: {
          salemanJoinId: this.data.salemanJoinId,
        },
      }).then((res) => {
        this.mLink = res.data
        this.visible = true;
        this.$emit('refresh',this.data)
      }).finally(()=>{
        this.$notice.hideLoading();
        // this.visible = true
      })
    },
    downloadImg(){
      const base64 = this.$refs.vueQr.$el.currentSrc;
      this.$units.dataToBlob(this.data.productName, base64);
    },
  },
}
</script>

<style lang="scss" scoped>
@import './getLinkModal.scss';
</style>
